import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4f166b8e"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "footer-buttons" };
const _hoisted_2 = ["disabled"];
const _hoisted_3 = ["disabled"];
const _hoisted_4 = ["disabled"];
import { deactivateIntegrations, saveAudience, saveIntegrations } from '@/features/AudienceManager/data';
import i18n from '@/i18n';
import router from '@/router';
import { disallowedCharsRegex, omnichatIndividualApproachStartDate } from '@/utilities/constants';
import moment from 'moment';
import { computed, ref, watch } from 'vue';
import { useToast } from 'vue-toastification';
import { useStore } from 'vuex';
export default /*#__PURE__*/ _defineComponent({
    __name: 'AudienceFooterButtons',
    setup(__props) {
        const store = useStore();
        const toast = useToast();
        const isSaveDisabled = ref(false);
        const isLoading = ref(false);
        const activateExportAudience = ref(false);
        const currentStep = computed(() => store.getters['audienceManager/activeStep']);
        const isViewMode = computed(() => store.getters['audienceManager/isView']);
        const audienceId = computed(() => store.getters['audienceManager/getAudienceId']);
        const audienceQuery = computed(() => store.getters['audienceManager/query']);
        const audienceHasConditions = computed(() => store.getters['audienceManager/hasAudienceData']);
        const connectorsToSave = computed(() => store.getters['audienceManager/getConnectorsToSave']);
        const integrationsToDeactive = computed(() => store.getters['audienceManager/integrationsToDeactive']);
        const totalPeople = computed(() => store.getters['audienceManager/totalPeople']);
        const isOmnichatAndIndividualApproach = computed(() => store.getters['audienceManager/isOmnichatAndIndividualApproach']);
        const activateExportationAudienceModal = computed(() => store.getters['audienceManager/activateExportationAudienceModal']);
        const isCreatingAudience = computed(() => !isViewMode.value);
        const getAudienceName = computed(() => store.getters['audienceManager/getAudienceName']);
        const isEmptyAudienceName = computed(() => !getAudienceName.value.trim());
        const isOnStepComposition = computed(() => currentStep.value === 1);
        const isOnStepIntegration = computed(() => currentStep.value === 2);
        const isOnStepHistoric = computed(() => currentStep.value === 3 && isViewMode.value);
        const goToIntegrationStep = () => {
            if (audienceHasConditions.value) {
                store.dispatch('audienceManager/changeStep', 2);
            }
        };
        const setErrorAudienceName = (value) => {
            store.commit('audienceManager/SET_ERROR_AUDIENCE_NAME', value);
        };
        const createAudience = async () => {
            const audienceName = store.getters['audienceManager/getAudienceName'].trim();
            isSaveDisabled.value = true;
            if (isEmptyAudienceName.value) {
                setErrorAudienceName(true);
                return;
            }
            if (disallowedCharsRegex.test(audienceName))
                return;
            if (!verifyStartDatetimeValidity())
                return;
            const params = {
                name: store.getters['audienceManager/getAudienceName'] || i18n.global.t('audiences.name-dafault'),
                description: '',
                query: audienceQuery.value,
                token: store.state.audienceManager.count.token,
            };
            store.commit('audienceManager/SET_LOADING_PAGE', true);
            saveAudience(params)
                .then(response => {
                if (response?.audienceId) {
                    updateIntegrations(response.audienceId, 'create');
                    toast.success(i18n.global.t('audiences.success-created'), { timeout: 1000 });
                    setTimeout(() => {
                        router.push({
                            name: 'base-audiences',
                        });
                    }, 2000);
                }
                else {
                    if (!audienceName.length) {
                        store.commit('audienceManager/SET_ERROR_AUDIENCE_NAME', true);
                        return;
                    }
                    if (disallowedCharsRegex.test(audienceName))
                        return;
                    toast.error(i18n.global.t(`audiences.error-created`), {
                        timeout: 3000,
                    });
                }
            })
                .finally(() => {
                isSaveDisabled.value = false;
                store.commit('audienceManager/SET_LOADING_PAGE', false);
            });
        };
        const getCurrentTimeWithFiveMinutesAdded = () => {
            return moment().second(0).add(5, 'minutes').format('YYYY-MM-DD HH:mm:ss');
        };
        const verifyStartDatetimeValidity = () => {
            const currentTime = getCurrentTimeWithFiveMinutesAdded();
            const hasInvalidDatetime = connectorsToSave.value
                .filter(conn => conn.startDatetime && conn.enabled && conn.editable)
                .some(conn => conn.startDatetime < currentTime);
            if (hasInvalidDatetime) {
                store.commit('audienceManager/UPDATE_VISIBILITY_INTEGRATION_MODAL', {
                    type: 'startTimeError',
                    value: true,
                });
                return false;
            }
            return true;
        };
        const updateIntegrations = async (audienceId, type = 'edit') => {
            const hasDeactivatedAll = await handleIntegrationDeactivation();
            if (!hasDeactivatedAll) {
                activateErrorModal();
                return;
            }
            await handleIntegrationCreation(audienceId, type);
        };
        const handleIntegrationDeactivation = async () => {
            if (!integrationsToDeactive.value.length)
                return true;
            const results = await Promise.all(integrationsToDeactive.value.map(integration => deactivateIntegrations(integration)
                .then(response => Boolean(response.success))
                .catch(() => false)));
            const hasDeactivatedAll = results.every(Boolean);
            if (hasDeactivatedAll)
                activateSuccessModal();
            return hasDeactivatedAll;
        };
        const handleIntegrationCreation = async (audienceId, type) => {
            isLoading.value = true;
            if (!connectorsToSave.value.length && type === 'edit') {
                activateSuccessModal();
                return;
            }
            connectorsToSave.value
                .filter(connector => connector.editable)
                .forEach(connector => {
                store.commit('audienceManager/UPDATE_VISIBILITY_MODAL', {
                    type: 'startTimeError',
                    value: true,
                });
                const verifyIfIsOmnichatAndIndividualApproach = connector.alias === 'omnichat' && isOmnichatAndIndividualApproach.value;
                const hasDatetime = () => {
                    if (!connector.startDatetime) {
                        if (verifyIfIsOmnichatAndIndividualApproach) {
                            return omnichatIndividualApproachStartDate;
                        }
                        else {
                            return '';
                        }
                    }
                    else {
                        return connector.startDatetime;
                    }
                };
                const configAsString = Array.isArray(connector.config) ? JSON.stringify(connector.config) : connector.config;
                const payload = {
                    audienceId,
                    aliasConnector: connector.alias,
                    interval: connector.interval,
                    instance: connector.instance,
                    startDate: hasDatetime(),
                    config: configAsString,
                    typeSendCampaign: verifyIfIsOmnichatAndIndividualApproach ? 0 : 1,
                };
                saveIntegrations(payload)
                    .then(response => {
                    if (response && type === 'edit') {
                        activateSuccessModal();
                    }
                })
                    .catch(() => {
                    activateErrorModal();
                })
                    .finally(() => {
                    isLoading.value = false;
                });
            });
        };
        const exportAudience = () => {
            if (totalPeople.value) {
                store.commit('audienceManager/ACTIVATE_EXPORTATION_AUDIENCE_MODAL', true);
            }
            else {
                toast.error(i18n.global.t('audiences.no-people-export'), { timeout: 6000 });
            }
        };
        const saveAndExportAudience = () => {
            activateExportAudience.value = true;
            exportAudience();
        };
        const saveAudienceChanges = () => {
            if (!verifyStartDatetimeValidity())
                return;
            updateIntegrations(audienceId.value);
        };
        const activateSuccessModal = () => {
            store.commit('audienceManager/ACTIVATE_INTEGRATIONS_SUCCESS_MODAL', true);
        };
        const activateErrorModal = () => {
            store.commit('audienceManager/ACTIVATE_INTEGRATIONS_ERROR_MODAL', true);
        };
        watch(activateExportationAudienceModal, isVisible => {
            if (!isVisible && activateExportAudience.value) {
                saveAudienceChanges();
                activateExportAudience.value = false;
            }
        }, { immediate: true });
        watch(getAudienceName, name => {
            const isEmptyName = !name;
            isSaveDisabled.value = Boolean(isEmptyName);
        }, { deep: true });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (isOnStepComposition.value)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (isCreatingAudience.value)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                disabled: !audienceHasConditions.value,
                                class: "btn btn-next",
                                onClick: goToIntegrationStep
                            }, _toDisplayString(_ctx.$t('audiences.next-step')), 9, _hoisted_2))
                            : (_openBlock(), _createElementBlock("button", {
                                key: 1,
                                class: "btn btn-export",
                                onClick: exportAudience
                            }, _toDisplayString(_ctx.$t('audiences.csv-export')), 1))
                    ], 64))
                    : _createCommentVNode("", true),
                (isOnStepIntegration.value)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        (isCreatingAudience.value)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                disabled: isSaveDisabled.value,
                                class: "btn btn-save",
                                onClick: createAudience
                            }, _toDisplayString(_ctx.$t('audiences.create-audience')), 9, _hoisted_3))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createElementVNode("button", {
                                    class: "btn btn-export",
                                    onClick: saveAndExportAudience
                                }, _toDisplayString(_ctx.$t('save-and-export')), 1),
                                _createElementVNode("button", {
                                    class: "btn btn-save",
                                    disabled: isLoading.value,
                                    onClick: saveAudienceChanges
                                }, _toDisplayString(_ctx.$t('save')), 9, _hoisted_4)
                            ], 64))
                    ], 64))
                    : _createCommentVNode("", true),
                (isOnStepHistoric.value)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 2,
                        class: "btn btn-export",
                        onClick: exportAudience
                    }, _toDisplayString(_ctx.$t('audiences.csv-export')), 1))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
